export const name = "REPEAT";
export const summary = `Produces a \`STRING\` or \`BYTES\` value that consists of an original value, repeated.`;
export const reference = `
## REPEAT

Produces a \`STRING\` or \`BYTES\` value that consists of an original value, repeated.

\`\`\`
REPEAT(original_value, repetitions)
\`\`\`

### Description

Returns a \`STRING\` or \`BYTES\` value that consists of \`original_value\`, repeated. The \`repetitions\` parameter specifies the number of times to repeat\`original_value\`. Returns \`NULL\` if either \`original_value\` or \`repetitions\`are \`NULL\`.

This function returns an error if the \`repetitions\` value is negative.


### Return type

\`STRING\` or \`BYTES\`


### Examples



\`\`\`
SELECT REPEAT('abc', 3) AS results

/*-----------*
 | results |
 |-----------|
 | abcabcabc |
 *-----------*/
\`\`\`



\`\`\`
SELECT REPEAT('abc', NULL) AS results

/*---------*
 | results |
 |---------|
 | NULL |
 *---------*/
\`\`\`



\`\`\`
SELECT REPEAT(NULL, 3) AS results

/*---------*
 | results |
 |---------|
 | NULL |
 *---------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/string_functions
`;
